var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, ChangeDetectorRef, OnChanges, OnInit, OnDestroy, ViewRef, EventEmitter, } from '@angular/core';
import { ControlValueAccessor, FormControl } from '@angular/forms';
import { isNullOrUndefined } from '../../extensions';
import { BaseComponent } from '../base.component';
import 'rxjs/add/operator/takeUntil';
var DateFieldComponent = /** @class */ (function (_super) {
    __extends(DateFieldComponent, _super);
    function DateFieldComponent(changeDetector) {
        var _this = _super.call(this) || this;
        _this.changeDetector = changeDetector;
        _this.errorText = '';
        _this.type = 'date';
        _this.iconColor = '#5cbcff';
        _this.change = new EventEmitter();
        return _this;
    }
    Object.defineProperty(DateFieldComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (newValue) {
            if (isNullOrUndefined(this._value) && isNullOrUndefined(newValue)) {
                return;
            }
            this._value = newValue && new Date(newValue);
            if (this._notifyChange) {
                this._notifyChange(this._value);
            }
            this.updateErrorText();
            this.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    DateFieldComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.updateFormat();
        if (this.formControl) {
            var oldMarkAsPristine_1 = this.formControl.markAsPristine.bind(this.formControl);
            this.formControl.markAsPristine = function (options) {
                oldMarkAsPristine_1(options);
                _this.isDisplayErrorMessage = false;
                _this.errorText = '';
                _this.detectChanges();
            };
        }
    };
    DateFieldComponent.prototype.writeValue = function (newValue) {
        this._value = newValue;
        if (!isNullOrUndefined(newValue)) {
            this._value = new Date(newValue);
        }
        this.detectChanges();
    };
    DateFieldComponent.prototype.registerOnChange = function (fn) {
        this._notifyChange = fn;
    };
    DateFieldComponent.prototype.registerOnTouched = function (fn) { };
    DateFieldComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () { return _this.writeValue(_this._value); });
    };
    DateFieldComponent.prototype.ngOnChanges = function () {
        if (this.min) {
            this.min = new Date(this.min);
        }
        if (this.max) {
            this.max = new Date(this.max);
        }
        this.updateFormat();
    };
    DateFieldComponent.prototype.onChange = function () {
        this.change.emit(this.value);
    };
    DateFieldComponent.prototype.onOpen = function () {
        // someone report the date picker fall bebind the shadow in DXP export pdf modal, so here set the zindex
        setTimeout(function () {
            var cdkContainers = document.querySelectorAll('.cdk-overlay-container');
            Array.from(cdkContainers).forEach(function (cdkContainer) {
                var datepicker = cdkContainer.querySelector('md2-datepicker-content');
                if (datepicker) {
                    cdkContainer.style.zIndex = '1001';
                }
                else {
                    console.log('datepicker not found');
                }
            });
        });
        this.detectChanges();
    };
    DateFieldComponent.prototype.onKeyPress = function ($event) {
        if ($event && $event.key === 'Enter') {
            this.picker.open();
        }
    };
    DateFieldComponent.prototype.onKeydown = function ($event) {
        this.picker._handleKeydown($event);
    };
    DateFieldComponent.prototype.clearValue = function ($event) {
        this.value = null;
        this.changeDetector.markForCheck();
        $event.stopPropagation();
    };
    DateFieldComponent.prototype.updateErrorText = function () {
        this.errorText = '';
        if (this.formControl && this.formControl.dirty && this.formControl.errors) {
            for (var _i = 0, _a = Object.keys(this.formControl.errors); _i < _a.length; _i++) {
                var key = _a[_i];
                if (!!this.customErrorTexts) {
                    var customErrorText = this.customErrorTexts[key];
                    if (customErrorText) {
                        this.errorText = customErrorText;
                        return;
                    }
                }
                switch (key) {
                    case 'required':
                        return (this.errorText = 'This field is required');
                    case 'timeRangeOverlapped':
                        return (this.errorText = 'Time range overlapped');
                }
            }
        }
    };
    DateFieldComponent.prototype.detectChanges = function () {
        var _this = this;
        setTimeout(function () {
            _this.changeDetector.markForCheck();
            if (!_this.changeDetector.destroyed) {
                _this.changeDetector.detectChanges();
            }
        });
    };
    DateFieldComponent.prototype.updateFormat = function () {
        if (!this.format) {
            this.format = this.type === 'date' ? 'MM-dd-yyyy' : 'MM-dd-yyyy HH:mm';
        }
    };
    return DateFieldComponent;
}(BaseComponent));
export { DateFieldComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/date.time.field/date.field.component.ts.pre-build-optimizer.js